import { Component, inject, output, signal } from '@angular/core';
import { ReactiveFormsModule, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { SettingsCmd } from '@app/core/config/settings';
import { BackendService } from '@app/shared/services/backend.service';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-admin-settings-new',
  templateUrl: './admin-settings-new.component.html',
  imports: [
    ReactiveFormsModule,
    TranslatePipe,
  ],
})
export class AdminSettingsNewComponent {
  private readonly backendService = inject(BackendService);
  private readonly translateService = inject(TranslateService);
  private readonly formBuilder = inject(UntypedFormBuilder);

  readonly reloadEntries = output();

  protected readonly newSettingForm = signal(this.generateForm());

  private generateForm(): UntypedFormGroup {
    return this.formBuilder.group({
      key_new         : ['', Validators.required],
      value_new       : ['', Validators.required],
      description_new : ['']
    });
  }

  protected submit() {
    const formValues = this.newSettingForm().value;
    const setting = new SettingsCmd({
      key         : formValues.key_new,
      value       : formValues.value_new,
      description : formValues.description_new,
    });
    this.backendService.createSetting(setting)
      .subscribe({
        next: () => {
          this.reset();
          this.reloadEntries.emit();
        },
        error: error => {
          this.showAlert();
          console.error(error);
        }
      });
  }

  protected reset() {
    this.newSettingForm.set(this.generateForm());
  }

  private showAlert() {
    Swal.fire({
      text              : this.translateService.instant('admin.settings.save.error'),
      icon              : 'error',
      buttonsStyling    : true,
      confirmButtonText : this.translateService.instant('global.ok')
    });
  }
}
